import { allPass, isNil, isEmpty, pipe, prop, filter, any, equals, values, head, not } from 'ramda';

const hasValidValue = value => !isNil(value) && !isEmpty(value);

// Nueva función para calcular el progreso de configuración del puesto
export const calculateJobProgress = (job) => {
	if (!job) return 0;

	const checks = [
		// Verificar si tiene al menos un verbo seleccionado
		() => {
			const hasVerbs = filter(
				levelKey => any(equals(true), values(prop(levelKey, job))),
				['highCommand', 'mediumCommand', 'lowCommand'],
			);
			return hasVerbs.length > 0;
		},
		// Verificar rol
		() => hasValidValue(prop('role', job)),
		// Verificar título
		() => hasValidValue(prop('title', job)),
		// Verificar experiencia
		() => hasValidValue(prop('experience', job)),
		// Verificar nivel de inglés
		() => hasValidValue(prop('englishLevel', job)),
		// Verificar cantidad de personas
		() => {
			const quantity = prop('quantityPerson', job);
			return hasValidValue(quantity) && quantity > 0;
		},
	];

	const completedChecks = checks.filter(check => check()).length;
	const totalChecks = checks.length;

	return Math.round((completedChecks / totalChecks) * 100);
};

// Nueva función para obtener el número de campos completados
export const getCompletedFieldsCount = (job) => {
	if (!job) return 0;

	const checks = [
		// Verificar si tiene al menos un verbo seleccionado
		() => {
			const hasVerbs = filter(
				levelKey => any(equals(true), values(prop(levelKey, job))),
				['highCommand', 'mediumCommand', 'lowCommand'],
			);
			return hasVerbs.length > 0;
		},
		// Verificar rol
		() => hasValidValue(prop('role', job)),
		// Verificar título
		() => hasValidValue(prop('title', job)),
		// Verificar experiencia
		() => hasValidValue(prop('experience', job)),
		// Verificar nivel de inglés
		() => hasValidValue(prop('englishLevel', job)),
		// Verificar cantidad de personas
		() => {
			const quantity = prop('quantityPerson', job);
			return hasValidValue(quantity) && quantity > 0;
		},
	];

	return checks.filter(check => check()).length;
};

export const generateJob = (jobName) => {
	const newJob = {
		additionalInformation: {
			immediateBoss: {},
			jobHeReplaces: [],
			jobItReplaces: [],
		},
		name: jobName,
		highCommand: {},
		mediumCommand: {},
		lowCommand: {},
		role: {},
		title: {},
		experience: {},
		englishLevel: {},
		quantityPerson: 1,
		completed: false,
		status: true,
		typeVerb: null,
	};

	// Calcular el progreso inicial
	newJob.progress = calculateJobProgress(newJob);

	return newJob;
};

export const verifyJobIsCompleted = allPass([
	pipe(
		job => filter(
			levelKey => any(equals(true), values(prop(levelKey, job))),
			['highCommand', 'mediumCommand', 'lowCommand'],
		),
		head,
		isNil,
		not,
	),
	pipe(prop('role'), hasValidValue),
	pipe(prop('title'), hasValidValue),
	pipe(prop('experience'), hasValidValue),
	pipe(prop('englishLevel'), hasValidValue),
	// pipe(prop('areaId'), hasValidValue),
	// pipe(prop('immediateBoss'), hasValidValue),
	// pipe(prop('jobHeReplaces'), hasValidValue),
	// pipe(prop('jobItReplaces'), hasValidValue),
	pipe(prop('quantityPerson'), value => hasValidValue(value) && value > 0),
]);



// WEBPACK FOOTER //
// ./src/modules/job-profile/helpers/helpers.js